import {Component, inject, Input, OnInit} from '@angular/core';
import {BaseError} from '../../../models/error/BaseError';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../../services/userInterface/toast.service';
import {BaseErrorService} from '../../../services/error/base-error.service';
import {ErrorPriority} from '../../../enums/ErrorPriority';

@Component({
    selector: 'app-base-error-detail-record',
    templateUrl: './base-error-detail-record.component.html',
    styleUrls: ['./base-error-detail-record.component.css'],
    standalone: true,
})
export class BaseErrorDetailRecordComponent<T extends BaseError> implements OnInit {
    private readonly translateService: TranslateService = inject(TranslateService)
    private readonly toastService: ToastService = inject(ToastService);
    private readonly errorService: BaseErrorService<T>;

    @Input({required: true}) errorId!: string;
    @Input() onErrorUpdated?: (error: BaseError) => void;

    protected isLoading: boolean = false;
    protected isSolving: boolean = false;
    protected error?: T;

    constructor(errorService: BaseErrorService<T>) {
        this.errorService = errorService;
    }

    public async ngOnInit() {
        if (!this.error) {
            await this.getDetailsOfSelectedError();
        }
    }

    public async updateErrorType(errorPriority: ErrorPriority) {
        if (this.error) {
            this.errorService.updateErrorType(this.error, errorPriority).subscribe({
                next: async () => {
                    if (this.onErrorUpdated && this.error) {
                        this.error.errorPriority = errorPriority;
                        this.onErrorUpdated(this.error);
                    }

                    await this.toastService.showSuccessMessage(this.translateService.instant("toastMessage.success.update"));
                },
                error: async () => {
                    await this.toastService.showErrorMessage(this.translateService.instant("toastMessage.error.update"));
                }
            });
        }
    }

    public async solveError() {
        if (this.error) {
            this.isSolving = true;
            this.errorService.solveError(this.error).subscribe({
                next: async () => {
                    if (this.onErrorUpdated && this.error) {
                        this.error.isSolved = true;
                        this.onErrorUpdated(this.error);
                    }

                    this.isSolving = false;
                    await this.toastService.showSuccessMessage(this.translateService.instant("toastMessage.success.update"));
                },
                error: async () => {
                    this.isSolving = false;
                    await this.toastService.showErrorMessage(this.translateService.instant("toastMessage.error.update"));
                }
            });
        }
    }

    private async getDetailsOfSelectedError() {
        this.isLoading = true;
        this.errorService.getById(this.errorId).subscribe({
            next: async (error) => {
                this.error = error;
                this.isLoading = false;
            },
            error: async () => {
                this.isLoading = false;
                await this.toastService.showErrorMessage("De opgevraagde fout kan niet worden gevonden."); // TODO translateService
            }
        });
    }
}
